import { WjpediaCnt } from '../../../store/wjpedia/types'
import { dictArr } from '../../utils/dictArr'
import client from '../client'

// 공통 호출 부분
async function searchHistory(searchObject: SearchObject) {
  await client.post<any>(`/api/reading`, searchObject)
}

// 진입 로그
export async function entryAppLog(
  CUSTOMER_NUMBER: string,
  CONTRACT_NUMBER: string,
  EXHIBITION_TP: string,
  SVC_TYPE?: string,
  PAGE_NO: string = ''
) {
  const searchObject: SearchObject = {
    requestApi: 'searchHistory',
    SVC_TYPE: SVC_TYPE || 'SA_ITGR', // 서비스명(모바일백과)
    SYS_TYPE: 'MOBILE',
    BOOK_CODE: '',
    CONTRACT_NUMBER: CONTRACT_NUMBER ?? '',
    CUSTOMER_NUMBER: CUSTOMER_NUMBER ?? '',
    EVENT_CODE: 'SRC_ETR',
    EXHIBITION_TYPE: EXHIBITION_TP, // 진입경로(음... 이건 어떻게 하지? 라운지 앱에서 진입했냐, 사이트 내에서 진입했냐 판별해야 할 거 같은데 )
    PAGE_NO: PAGE_NO, // 라운지 알림 > 모바일 포토백과 진입 시 '' 아니고 이벤트 번호가 들어감
  }

  try {
    await searchHistory(searchObject)
  } catch (e) {
    console.error(e)
  }
}

// 검색 로그
export async function searchResultLog(
  CUSTOMER_NUMBER: string,
  CONTRACT_NUMBER: string,
  INPUT_VALUE: string,
  wjpediaCnt: WjpediaCnt[],
  method?: string
) {
  const RESULT_DSC: any = {}
  wjpediaCnt
    .filter((dict) => dict.dictName !== '전체')
    .forEach((dict) => {
      RESULT_DSC[dict.dictCd!] = dict.dictCnt
    })

  const searchObject: SearchObject = {
    requestApi: 'searchHistory',
    SVC_TYPE: 'SA_ITGR', // 서비스명(모바일백과)
    SYS_TYPE: 'MOBILE',
    BOOK_CODE: '',
    CONTRACT_NUMBER: CONTRACT_NUMBER ?? '',
    CUSTOMER_NUMBER: CUSTOMER_NUMBER ?? '',
    EVENT_CODE: 'SRC_EXE',
    EXHIBITION_TYPE: '',
    PAGE_NO: '',
    INPUT_VALUE: INPUT_VALUE,
    RESULT_TOT: wjpediaCnt?.[0]?.dictCnt ? String(wjpediaCnt?.[0]?.dictCnt) : '1',
    RESULT_DSC:
      JSON.stringify(RESULT_DSC) !== '{}'
        ? JSON.stringify(RESULT_DSC)
        : '{"ISSUE":0,"ECCPD":1,"DIC3D":0,"BIOLOGY":0,"NARIS":0,"COUNTRY":0,"KODIC":0,"VISIT_PHTG":0,"ROYAL":0,"CTLHRIT":0,"MUSM":0,"KORSAM":0,"STDDIC":0,"STDECC":0,"ENGDIC":0}',
    METHOD: method ?? 'NL',
  }

  try {
    await searchHistory(searchObject)
  } catch (e) {
    console.error(e)
  }
}

// 상세 로그
export async function detailViewLog(
  CUSTOMER_NUMBER: string,
  CONTRACT_NUMBER: string,
  INPUT_VALUE: string,
  dictIdx: number | string,
  dictSeq?: string
) {
  const searchObject: SearchObject = {
    requestApi: 'searchHistory',
    SVC_TYPE: 'SA_ITGR', // 서비스명(모바일백과)
    SYS_TYPE: 'MOBILE',
    BOOK_CODE: '',
    CONTRACT_NUMBER: CONTRACT_NUMBER ?? '',
    CUSTOMER_NUMBER: CUSTOMER_NUMBER ?? '',
    EVENT_CODE: 'SRC_VIEW',
    EXHIBITION_TYPE: '',
    PAGE_NO: '',
    INPUT_VALUE: INPUT_VALUE,
    KYWR_NAME: INPUT_VALUE,
    RESULT_TOT: '',
    RESULT_DSC: '',
    METHOD: '',
    DICT_DVSN_CD: typeof dictIdx === 'number' ? dictArr[dictIdx].dictCd : dictIdx,
    DICT_UNIQ_ID: String(dictSeq),
  }

  try {
    await searchHistory(searchObject)
  } catch (e) {
    console.error(e)
  }
}

type SearchObject = {
  requestApi: 'searchHistory'
  SVC_TYPE: 'SA_ITGR' | 'SA_ITGR_EVNT' | string // 서비스명(그냥 백과서비스)
  SYS_TYPE: 'WEB' | 'PAD' | 'MOBILE'
  BOOK_CODE: string
  CONTRACT_NUMBER: string
  CUSTOMER_NUMBER: string
  EVENT_CODE: 'SRC_ETR' | 'SRC_EXE' | 'SRC_VIEW'
  EXHIBITION_TYPE: string // 진입경로(음... 이건 어떻게 하지? 라운지 앱에서 진입했냐, 사이트 내에서 진입했냐 판별해야 할 거 같은데 )
  PAGE_NO: string
  INPUT_VALUE?: string
  METHOD?: string
  RESULT_DSC?: string
  RESULT_TOT?: string
  KYWR_NAME?: string
  DICT_DVSN_CD?: string
  DICT_UNIQ_ID?: string
}
